import { render, staticRenderFns } from "./CompaniesSelector.vue?vue&type=template&id=12d23e3e"
import script from "./CompaniesSelector.vue?vue&type=script&lang=js"
export * from "./CompaniesSelector.vue?vue&type=script&lang=js"
import style0 from "./CompaniesSelector.vue?vue&type=style&index=0&id=12d23e3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports